import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Html from '~/components/blocks/core/Html';

const HtmlBlock = ({ html }) => <Html {...{ html }} />;

HtmlBlock.propTypes = {
    html: PropTypes.string.isRequired
};

export default HtmlBlock;

export const fragment = graphql`
    fragment HtmlBlockFragment on WpCoreHtmlBlock {
        html: originalContent
    }
`;

export const exampleData = [
    {
        variant: 'Custom Code',
        props: {
            name: 'core/html',
            html: '<div style="display: flex; align-items: center; justify-content: center;"><div style="position: relative; text-transform: uppercase; text-shadow: -15px 5px 20px #444B53; color: #FFD200; letter-spacing: -0.05em; font-size: 68px;"><span>A</span><span>u</span><span>t</span><span>o</span><span>b</span><span>e</span><span>l</span><span>l</span></div></div>'
        }
    }
];
